import { render, staticRenderFns } from "./TranslationDropdown.vue?vue&type=template&id=6fd613ec&scoped=true&"
import script from "./TranslationDropdown.vue?vue&type=script&lang=js&"
export * from "./TranslationDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TranslationDropdown.vue?vue&type=style&index=0&id=6fd613ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd613ec",
  null
  
)

export default component.exports